import { MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE } from "../../../../sitel/commons/utilities/medstarAssociationType";
import NoneEmployeeHeader from "./noneEmployeeHeader";
import PreEmployeeHeader from "./preEmployeeHeader";

export default function HeaderSection({medstarAssociationType,register,errors}){
    if(medstarAssociationType === MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE){
        return (
            <PreEmployeeHeader register={register} errors={errors} />
        );
    } else {
        return (
            <NoneEmployeeHeader />
        );
    }

}
